import * as React from 'react';
import { Prompt } from 'react-router';
import { reduxForm } from 'redux-form';
import { compose, withProps } from 'recompose';
import { get } from 'lodash';
import { format } from 'date-fns';
import { Card } from 'material-ui/Card';

import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';

import { InventoryCardsFormBasic } from '@modules/inventoryCards/InventoryCardsFormBasic';

import { getInventoryCard, defaultInventoryCard } from '@modules/inventoryCards/_inventoryCardsActions';
import * as T from '@modules/inventoryCards/_inventoryCardsTypes';

export const enhance = compose<T.InventoryCardFormProps, T.Outter>(
  entityDetailEnhancer<T.InventoryCardEnhancerProps<T.InventoryCard>, T.InventoryCard>({
    getEntity: getInventoryCard,
    defaultEntity: defaultInventoryCard
  }),
  breadcrumbs(({ entity }) => [
    { label: 'Skladové karty', to: '/warehouses/inventory-cards' },
    { label: get(entity, 'id') ? 'Upravit záznam' : 'Nový záznam' }
  ]),
  withProps<{}, T.InventoryCardProps>(({ entity }) => ({
    initialValues: {
      ...entity
    },
    maxYear: format(new Date(), 'YYYY')
  })),
  reduxForm({
    form: 'module-tickets'
  })
);

export const View: React.SFC<T.Outter & T.InventoryCardFormProps> = props => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <InventoryCardsFormBasic />
        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={props.closeItem} />
      </Card>
    </form>
  </div>
);

export const InventoryCardsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/inventoryCards/InventoryCardsForm.tsx